<template>
  <div class="jsjyDtail">
    <Header title="调课审核"></Header>
    <div
      :class="{
        'jsjyDtail-header': true,
        [returnUrl()]: true
      }"
    >
      <h2>{{ itemList.kcmc }}</h2>
      <ul class="jsjyDtail-info">
        <li>
          <p>教师：</p>
          <span>{{ itemList.oldjsmc }}</span>
        </li>
        <li>
          <p>调课方式：</p>
          <span>{{ itemList.tkfs }}</span>
        </li>
        <li>
          <p>院系：</p>
          <span>{{ itemList.dwmc }}</span>
        </li>
        <li>
          <p>调课类型：</p>
          <span>{{ itemList.tklx }}</span>
        </li>
        <li style="width:100%">
          <p>班级：</p>
          <span>{{ itemList.ktmc }}</span>
        </li>
      </ul>
      <img
        v-if="!isApply"
        :src="require(`@/assets/images/${returnUrl()}.png`)"
        alt=""
        class="img"
      />
    </div>
    <qz-content
      :itemList="itemList"
      :listProps="listProps"
      :filemap="filemap"
      :isApply="false"
    >
    </qz-content>
    <div v-if="routeQuery.type != 'detail'" class="jsjyDtail-button">
      <van-button type="primary" round @click="pass">
        审核
      </van-button>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import { returnUrl, returnFileType } from "@/utils/exChang";
export default {
  data() {
    return {
      showShjl: false,
      isApply: false,
      showPicker: false,
      routeQuery: {},
      itemList: {},
      shjlList: [],
      filemap: []
    };
  },
  computed: {
    listProps() {
      return [
        {
          label: "时间模式",
          prop: "oldkbjcmsid"
        },
        {
          label: "上课周次",
          prop: "ykkzc"
        },
        {
          label: "新上课周次",
          prop: "xkkzc"
        },
        {
          label: "待调整周次",
          prop: "kkzc",
          line: true
        },
        {
          label: "时间",
          prop: "kcsj"
        },
        {
          label: "原时间",
          prop: "ykcsj",
          line: true
        },
        {
          label: "教师",
          prop: "jsmc",
          isShow: item => {
            return item.tklx == "变更教师";
          }
        },
        {
          label: "原教师",
          prop: "skls",
          isShow: item => {
            return item.tklx == "变更教师";
          },
          line: true
        },
        {
          label: "地点",
          prop: "xjsmc"
        },
        {
          label: "原地点",
          prop: "yjsmc",
          line: true
        },
        {
          label: "单双周",
          prop: "dsz",
          line: true
        },
        {
          label: "调课原因",
          prop: "tkyy",
          type: "textarea",
          line: true
        },
        {
          label: "附件",
          type: "file"
        }
      ];
    }
  },
  created() {
    this.routeQuery = JSON.parse(this.$route.params.route_params);
    this.query();
  },
  methods: {
    isShow(item) {
      return false;
    },
    getShowShjl(val) {
      this.showShjl = val;
    },
    onConfirm(value, index) {
      this.showPicker = false;
      this.bjLabel = value.text;
      this.bjVlaue = value.value;
      this.query();
    },
    query() {
      Api.getTkck({
        tkid: this.routeQuery.ywinstanceid
      }).then(res => {
        this.itemList = res.jx0408ttkList[0] || [];
        this.itemList.oldjsmc = res.changeJgold;
        Object.assign(this.itemList, this.routeQuery);

        if (res.code != 0) {
          if (res.filemap && res.filemap.fileName) {
            let flag = res.filemap.fileName.split(".")[1];
            res.filemap.type = returnFileType(flag);
            this.$set(this.filemap, 0, res.filemap);
          }
        }
      });
    },
    pass() {
      let obj = {
        id_sh: this.routeQuery.id,
        xq_id: this.routeQuery.ywinstanceid,
        sh_flag: "009",
        route: "/tksh/index"
      };
      this.$router.push({
        name: "tkshCommompass",
        params: {
          route: "adjustListDetail,1",
          route_params: encodeURI(JSON.stringify(obj))
        }
      });
    },
    returnUrl() {
      return returnUrl(this.routeQuery.iswfmes);
    }
  }
};
</script>

<style lang="less" scoped>
.jsjyDtail {
  padding-bottom: 50px;
  .jsjyDtail-header {
    position: relative;
    border-radius: 0 0 8px 8px;
    padding: 16px 20px;

    &.ytg {
      background-image: linear-gradient(244deg, #41b28d 0%, #41b29c 100%);
    }
    &.btg,
    &.warn {
      background-image: linear-gradient(136deg, #7469f8 0%, #df5b4e 100%);
    }
    &.warn {
      .img {
        width: 80px;
        height: 70px;
        margin-right: -15px;
        margin-bottom: -15px;
      }
    }
    &.ycs {
      background-color: #aaaaaa;
    }
    &.dsh,
    &.shz {
      background-image: linear-gradient(-48deg, #ffa500 0%, #f1822d 100%);
    }

    h2 {
      margin-bottom: 8px;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: bold;
    }
    .jsjyDtail-jsmc {
      display: flex;
      span {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 22px;
        font-weight: 400;
      }
    }
    .jsjyDtail-info {
      display: flex;
      flex-wrap: wrap;
      li {
        display: flex;
        width: 50%;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 14px;
        margin-top: 8px;
        font-weight: 400;
        p {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 14px;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
    .img {
      width: 75.93px;
      height: 69.85px;
      position: absolute;
      top: 8px;
      right: 0;
    }
  }
  .allClass {
    display: flex;
    align-items: center;
    width: 97px;
    height: 34px;
    background: #ffffff;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #7469f8;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    padding: 5px;

    span {
      flex: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .van-icon {
      transform: rotate(90deg);
      color: #7469f8;
    }
  }
  .QzList .QzList-list {
    .qzlist-top {
      display: flex;
      align-items: center;
      h2 {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
        margin-bottom: 5px;
      }
      span.cjbs {
        width: 46px;
        height: 18px;
        background-color: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(153, 153, 153, 0.2);
        border-radius: 9px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(153, 153, 153, 0.2);
        letter-spacing: 0;
        font-weight: 400;
        margin-left: 3px;
      }
    }

    .qzlist-bottom {
      display: flex;
      padding: 7.5px 0 0;
      margin-bottom: -4px;
      border-top: 0.5px dashed #e5e5e5;
      li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h3 {
          line-height: 22px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #595959;
          letter-spacing: 0;
          text-align: center;
          font-weight: bold;
        }
        span {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #999999;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
          line-height: 17px;
        }
      }
    }
  }
  .jsjyDtail-button {
    position: fixed;
    display: flex;
    width: 100%;
    bottom: 0;
    left: 0;
    background-color: #fff;
    padding: 10px 15px;
    &::before {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 0;
      left: 16px;
      border-top: 1px solid #e5e5e5;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .van-button {
      width: calc(~'100% - 30px');
      height: 50px;
      background: #7469f8;
      border: none;
      font-size: 18px;
      & + .van-button {
        margin-left: 15px;
      }
    }
  }
}
/deep/.QzList-list-tag {
  margin-bottom: 7.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/tksh/tkshDetail.vue